import React from "react"
import { Link } from "gatsby-plugin-react-i18next"
import { useTranslation } from "react-i18next"

const NavItem = ({ page, closeMenu, locationName }) => {
  const { t } = useTranslation()
  return (
    <li
      className={
        "/" + locationName === page.link
          ? "menu-nav__item active"
          : "menu-nav__item"
      }
    >
      <Link to={page.link} className="menu-nav__link" onClick={closeMenu}>
        <span>{t(page.name + ".name")}</span>
      </Link>
    </li>
  )
}

const NavLinks = ({ menuLinks, closeMenu, locationName }) => {
  return (
    <>
      {menuLinks?.map(page => (
        <NavItem
          page={page}
          key={page.name}
          closeMenu={closeMenu}
          locationName={locationName}
        />
      ))}
    </>
  )
}

export default NavLinks
